const ITEMS = [
    "Technology",
    "Efficiency",
    "Decisions",
    "Smarter Workflows",
    "Stronger Businesses",
];

const Diamond = () => (
    <span
        className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-gradient-to-br from-[#00E5FF] to-[#D946EF]"
        aria-hidden="true"
    />
);

const Sequence = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="font-mono-brand text-xs uppercase tracking-[0.35em] text-[#475569] sm:text-sm">
                    {item}
                </span>
                <Diamond />
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        className="relative z-10 overflow-hidden border-t border-white/5 py-5"
        data-testid="editorial-marquee"
        aria-hidden="true"
    >
        <div className="marquee-track flex w-max">
            <Sequence />
            <Sequence />
            <Sequence />
            <Sequence />
        </div>
    </div>
);

export default Marquee;
